import { render, staticRenderFns } from "./TransactionLogs.vue?vue&type=template&id=2a49f34c&"
import script from "./TransactionLogs.vue?vue&type=script&lang=js&"
export * from "./TransactionLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports